module.exports = __webpack_public_path__ + "img/login-logo.1dce5e3f.png";